import { HTMLAttributes, ReactNode } from 'react';
import { ElementType } from 'react';

export enum JobLabelVariant {
  NEW_JOB = 'NEW_JOB',
  RECOMMENDED_FOR_YOU = 'RECOMMENDED_FOR_YOU',
  HIRING_FAST = 'HIRING_FAST',
  HIRING_HERO = 'HIRING_HERO',
  RESPONSIVE_EMPLOYER = 'RESPONSIVE_EMPLOYER',
}

export interface JobLabelDataProps {
  text: string;
  mobileText?: string;
  icon?: ElementType;
  tooltip?: {
    icon: ElementType;
    el: ReactNode;
  };
}

export type JobLabelProps = {
  /**
   * The appeal variant of the job label
   * @required
   */
  variant: JobLabelVariant;
} & HTMLAttributes<HTMLElement>;
